var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexiNewHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 948.333,
    height: 244.3,
    viewBox: "0 0 948.333 244.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9828",
    "data-name": "Group 9828",
    transform: "translate(-6872 -7193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12392",
    "data-name": "Path 12392",
    d: "M689.4,97.1v87.4h35.7v15.6H674.3V97.1Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#800020",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12393",
    "data-name": "Path 12393",
    d: "M750.2,123.3a35.172,35.172,0,0,0-10.4,25.6,35.654,35.654,0,1,0,71.3,1.1v-1.1a35.581,35.581,0,0,0-34.7-36.3A36.085,36.085,0,0,0,750.2,123.3Zm-10.7,62.2a51.116,51.116,0,1,1,86.6-37.8V149a50.494,50.494,0,0,1-86.6,36.5",
    transform: "translate(6751.7 7166.1)",
    fill: "#800020",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12394",
    "data-name": "Path 12394",
    d: "M860.8,161h24.4V121Zm39.4-63.9V201H885.1V176.8H851.2L836.6,201H818.7L881.6,97.1Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#800020",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12395",
    "data-name": "Path 12395",
    d: "M989.7,97.1V201H973.9l-42.6-74.3V201H916.2V97.1H932l42.6,74.3V97.1Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#800020",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12396",
    "data-name": "Path 12396",
    d: "M1032.6,201.7a38.037,38.037,0,0,1-18.6-5.5,29.106,29.106,0,0,1-13.2-15.3l14.5-5.4a14.474,14.474,0,0,0,7.3,7.7,26.1,26.1,0,0,0,10.6,2.8,20.83,20.83,0,0,0,14.8-4.4,12.831,12.831,0,0,0,5.2-9.3q.45-9.9-20.4-15.9c-21.7-6.2-32.3-16.8-31.6-31.7q.6-15.6,13.2-23.4a39.059,39.059,0,0,1,22.9-5.3c10.8.5,19.5,4.3,26,11.5L1052,118.2c-3.7-4.1-8.8-6.2-15.4-6.6a27.02,27.02,0,0,0-11.9,1.8,12.469,12.469,0,0,0-8,11.9c-.3,6.5,6.5,11.7,20.4,15.7,12.5,3.6,21.3,8.8,26.5,15.8a24.252,24.252,0,0,1,5,16,28.351,28.351,0,0,1-10.9,20.9,35.315,35.315,0,0,1-23.2,7.9l-1.9.1",
    transform: "translate(6751.7 7166.1)",
    fill: "#800020",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12397",
    "data-name": "Path 12397",
    d: "M260,77.3V99H208.6v39h39.7v21.7H208.6v61.1H186.8V77.3Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#2b5582",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12398",
    "data-name": "Path 12398",
    d: "M295.5,77.3V220.8H222.3V199.1h51.5V77.3Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#800020",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12399",
    "data-name": "Path 12399",
    d: "M362,147.6h0v-.5a48.05,48.05,0,0,0-.2-5,117.354,117.354,0,0,0-3.7-23.5,124.907,124.907,0,0,0-14.4-34.1,121.458,121.458,0,0,0-57.6-49.1,118.538,118.538,0,0,0-29.2-7.6c-2.6-.4-5.2-.5-8-.7l-11.8-.2c-.6,0-1.2.1-1.8.1a15.483,15.483,0,0,1-2.2.1c-2.2.1-4.4.4-6.5.6l-1.6.2a129.57,129.57,0,0,0-16.2,3.4c-2,.5-4,1.2-6,1.9l-6,2.2c-1.3.5-2.7,1.1-4,1.7a122.632,122.632,0,0,0-52.5,45,126.2,126.2,0,0,0-15,32.5,120.131,120.131,0,0,0-3.8,17.6,133.438,133.438,0,0,0-1.2,17.9l.1,4.5c0,1.4.1,2.7.2,4.1v.5c.2,3.1.6,6.2,1,9a122.515,122.515,0,0,0,4.1,17.7,119.528,119.528,0,0,0,6.6,16.6,145.9,145.9,0,0,0,8.8,15.4,121.75,121.75,0,0,0,52.4,43.4c1.3.6,2.6,1.2,3.9,1.7l3.9,1.5c.9.3,1.8.6,2.6.8,1.7.6,3.5,1.1,5.2,1.6a108.129,108.129,0,0,0,16,3.3l1.7.2q3.15.45,6.3.6l1.3.1a26.2,26.2,0,0,0,2.8.1h6.3c1.8,0,3.6-.1,5.4-.2l2.4-.2c1.8-.1,3.6-.3,5.3-.5a119.613,119.613,0,0,0,53-20.4,123.586,123.586,0,0,0,33.1-34.5,109.732,109.732,0,0,0,9.3-17.6,108.127,108.127,0,0,0,5.6-16,114.759,114.759,0,0,0,4-23.3q.3-3.15.3-6.3Zm-3.5,2.8v3.3a43.635,43.635,0,0,1-.2,4.8,108.945,108.945,0,0,1-3.9,22.7,110.879,110.879,0,0,1-14.9,32.4,112.735,112.735,0,0,1-32.8,32.1,120.249,120.249,0,0,1-23.6,11.6,111.438,111.438,0,0,1-27.3,6.2,57.833,57.833,0,0,1-7.1.5h-2.5c-1.6,0-3.2.1-4.9,0l-3.8-.1a19.417,19.417,0,0,1-2.4-.2l-1.3-.1a54.3,54.3,0,0,1-5.5-.6l-1.9-.3a110.61,110.61,0,0,1-14.9-3.4,49.936,49.936,0,0,1-5.1-1.6c-.8-.3-1.5-.5-2.2-.8l-3.7-1.5-3.6-1.5a113.534,113.534,0,0,1-48-41.2,117.542,117.542,0,0,1-7.9-14.3,111.808,111.808,0,0,1-9.2-31.5,127.85,127.85,0,0,1-1.1-16.4,129.611,129.611,0,0,1,1.4-16.5,123.78,123.78,0,0,1,3.7-16,104.841,104.841,0,0,1,6.1-15.2A112.562,112.562,0,0,1,198,49c1.1-.5,2.3-1,3.5-1.5l5.4-2c1.8-.6,3.6-1.2,5.4-1.7a126.1,126.1,0,0,1,14.5-3.3l1.8-.2c1.8-.2,3.7-.5,5.5-.6l1.2-.1a19.419,19.419,0,0,1,2.4-.2l10.8-.1a21.751,21.751,0,0,0,2.5.1c1.5.1,3,.2,4.4.3l1.1.1a53.989,53.989,0,0,1,5.8.8l1.2.2a16.958,16.958,0,0,1,2.2.4l3.4.7a52.781,52.781,0,0,1,6.6,1.6l1.6.5,4.8,1.5a118.529,118.529,0,0,1,23.3,11.1,113.46,113.46,0,0,1,32.9,31.1,109.482,109.482,0,0,1,19.6,54.4,42.056,42.056,0,0,1,.3,4.5v1.7h-.1Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#2b5582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12400",
    "data-name": "Path 12400",
    d: "M385.4,201.8V97.1h55.8v8.8H393.5v38.5H432v8.7H393.5v48.7h-8.1Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#2b5582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12401",
    "data-name": "Path 12401",
    d: "M501.8,201.8H446.1V97.1h8.1v96.3h47.6Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#2b5582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12402",
    "data-name": "Path 12402",
    d: "M561.6,201.8H506.3V97.1h55.8v8.8H514.6v38.8h37.7v8.6H514.6V193h46.9v8.8Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#2b5582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12403",
    "data-name": "Path 12403",
    d: "M601.8,150.1l30,51.7h-9.6l-25.1-43.1h-.4l-25.3,43.1h-9.5L592,150.4,560.7,97.1h9.5l26.3,45h.4l26.7-45h9.6Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#2b5582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12404",
    "data-name": "Path 12404",
    d: "M635.6,201.8V97.3H644V201.8Z",
    transform: "translate(6751.7 7166.1)",
    fill: "#2b5582"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexiNewHeader);
export default __webpack_public_path__ + "static/media/flexi_new_header.f5cc5a9bc9dc506ad59aac7172ae89d7.svg";
export { ForwardRef as ReactComponent };